<div class="pos-r">
  <app-loader *ngIf="dataLoading"></app-loader>
  <form *ngIf="!dataLoading" [formGroup]="companyCreateEditForm">
    <app-loader *ngIf="createEditLoading"></app-loader>
    <steps (onSaveStepsCallback)="onSaveStepCallback()" (onResetStepsCallback)="onResetStepsCallback()">
      <step [title]="'Шаг 1'" [description]="'Основная информация<br> Адреса'">
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Основная информация</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Форма юр. лица</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <input type="hidden" formControlName="ownership_type" />
                    <app-combobox
                      [items]="ownershipTypes"
                      (callback)="onChangeOwnershipType($event)"
                      [textKey]="'ot_full'"
                      [defaultText]="'Выберите значение'"
                      [initBy]="ownershipTypeInit"
                      [name]="'ownershipType'"
                    ></app-combobox>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Наименование</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="psName" formControlName="ps_name" fieldRegexp [regexp]="'[`\'&quot;]'" fieldTrim />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3"></div>
                  <div class="grid__box grid__box--size-9">
                    <app-checkbox>
                      <input type="checkbox" id="psCompany" formControlName="is_main" />
                      <checkbox-text>Компания-заказчик</checkbox-text>
                    </app-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-24 mb-24">
          <div class="grid__box--size-4">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Адреса</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="title">Юридический</div>
                <div class="grid grid--gap0 mt-24">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Индекс</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div class="grid grid--gap-0">
                      <div class="grid__box grid__box--size-3">
                        <app-field>
                          <input
                            class="input-text input-text--validation"
                            type="text"
                            required
                            formControlName="legal_postcode"
                            id="legalPostcode"
                            fieldRegexp
                            [regexp]="'[^0-9]'"
                            maxlength="6"
                            pattern="^.{6,}$"
                        /></app-field>
                      </div>
                      <div class="grid__box grid__box--size-12">
                        <div class="label__error" *ngIf="companyCreateEditForm.value.legal_postcode.length >= 1 && companyCreateEditForm.controls.legal_postcode.invalid">
                          Не корректный индекс
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Страна</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="laCountry" formControlName="la_country" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Область</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="laRegionName" formControlName="la_region_name" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Город</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="laCityName" formControlName="la_city_name" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Тип улицы</span>
                  </div>
                  <div class="grid__box grid__box--size-9 dropdown-menu--small">
                    <input type="hidden" formControlName="la_street_type" />
                    <app-combobox
                      [items]="streetTypes"
                      (callback)="onChangeLaStreetType($event)"
                      [textKey]="'st_type'"
                      [defaultText]="'Выберите значение'"
                      [initBy]="laStreetTypeInit"
                      [name]="'laStreetType'"
                    ></app-combobox>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Улица</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="laStreetName" formControlName="la_street_name" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Дом</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div class="grid grid--gap-0">
                      <div class="grid__box grid__box--size-3">
                        <div class="grid">
                          <div class="grid__box grid__box--size-8">
                            <app-field>
                              <input class="input-text" type="text" id="laHouseNumber" formControlName="la_house_number" />
                            </app-field>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-8 grid--va-middle">
                          <div class="grid__box ta-right">
                            <span class="title title--s">Строение</span>
                          </div>
                          <div class="grid__box grid__box--size-5">
                            <app-field>
                              <input class="input-text" type="text" id="laHouseBuilding" formControlName="la_house_building" />
                            </app-field>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-8 grid--va-middle">
                          <div class="grid__box ta-right">
                            <span class="title title--s">Офис</span>
                          </div>
                          <div class="grid__box grid__box--size-5">
                            <app-field>
                              <input class="input-text" type="text" id="laOfficeNumber" formControlName="la_office_number" />
                            </app-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid__box grid__box--size-5 ml-80">
                <div class="title">Фактический</div>
                <div class="grid mt-24">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Индекс</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div class="grid grid--gap-0">
                      <div class="grid__box grid__box--size-3">
                        <app-field>
                          <input
                            class="input-text input-text--validation"
                            type="text"
                            required
                            formControlName="physical_postcode"
                            id="physicalPostcode"
                            fieldRegexp
                            [regexp]="'[^0-9]'"
                            maxlength="6"
                          />
                        </app-field>
                      </div>
                      <div class="grid__box grid__box--size-12">
                        <div
                          class="label__error"
                          *ngIf="
                            companyCreateEditForm.value.physical_postcode &&
                            companyCreateEditForm.value.physical_postcode.length >= 1 &&
                            companyCreateEditForm.controls.physical_postcode.invalid
                          "
                        >
                          Не корректный индекс
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Страна</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="paCountry" formControlName="pa_country" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Область</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="paRegionName" formControlName="pa_region_name" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Город</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="paCityName" formControlName="pa_city_name" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Тип улицы</span>
                  </div>
                  <div class="grid__box grid__box--size-9 dropdown-menu--small">
                    <input type="hidden" formControlName="pa_street_type" />
                    <app-combobox
                      [items]="streetTypes"
                      (callback)="onChangeFaStreetType($event)"
                      [textKey]="'st_type'"
                      [defaultText]="'Выберите значение'"
                      [initBy]="paStreetTypeInit"
                      [isDisabled]="addresses_equal"
                      [name]="'paStreetType'"
                    ></app-combobox>
                  </div>
                </div>
                <div class="grid mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Улица</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="paStreetName" formControlName="pa_street_name" />
                    </app-field>
                  </div>
                </div>
                <div class="grid grid--gap-0 mt-16">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Дом</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div class="grid grid--gap-0">
                      <div class="grid__box grid__box--size-3">
                        <div class="grid">
                          <div class="grid__box grid__box--size-8">
                            <app-field>
                              <input class="input-text" type="text" id="paHouseNumber" formControlName="pa_house_number" />
                            </app-field>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-8 grid--va-middle">
                          <div class="grid__box ta-right">
                            <span class="title title--s">Строение</span>
                          </div>
                          <div class="grid__box grid__box--size-5">
                            <app-field>
                              <input class="input-text" type="text" id="paHouseBuilding" formControlName="pa_house_building" />
                            </app-field>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-8 grid--va-middle">
                          <div class="grid__box ta-right">
                            <span class="title title--s">Офис</span>
                          </div>
                          <div class="grid__box grid__box--size-5">
                            <app-field>
                              <input class="input-text" type="text" id="paOfficeNumber" formControlName="pa_office_number" />
                            </app-field>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="mt-24">
              <app-checkbox>
                <input type="checkbox" id="addressesEqual" formControlName="addresses_equal" />
                <checkbox-text>Фактический адрес совпадает с юридическим</checkbox-text>
              </app-checkbox>
            </div>
          </div>
        </div>
      </step>
      <step [title]="'Шаг 2'" [description]="'Договор<br> Дополнительные настройки<br> Сведения об изменении'">
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Договор</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-6">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Номер</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="psContract" formControlName="ps_contract" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Период действия</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div class="grid">
                      <div class="grid__box">
                        <div class="grid grid--gap-4 grid--va-middle">
                          <div class="grid__box grid__box--size-min">c</div>
                          <div class="grid__box">
                            <input type="hidden" formControlName="effective_date" />
                            <app-date-time-picker
                              [initDate]="effectiveDateInit"
                              [isShowTimepicker]="false"
                              [datepickerName]="'effectiveDateStart'"
                              (dateCallback)="onChangeBeginPeriodDate($event)"
                            ></app-date-time-picker>
                          </div>
                        </div>
                      </div>
                      <div class="grid__box">
                        <div class="grid grid--gap-4 grid--va-middle">
                          <div class="grid__box grid__box--size-min">по</div>
                          <div class="grid__box">
                            <input type="hidden" formControlName="expiration_date" />
                            <app-date-time-picker
                              [initDate]="expirationDateInit"
                              [isShowTimepicker]="false"
                              [datepickerName]="'expirationDateEnd'"
                              [options]="expirationDateEndOpts"
                              (dateCallback)="onChangeEndPeriodDate($event)"
                            ></app-date-time-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-24 mb-24">
          <div class="grid__box--size-4">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Дополнительные настройки</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-6">
                <div class="grid">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Домены электронной почты компании</span>
                  </div>
                  <div class="grid__box grid__box--size-9" formArrayName="domains">
                    <div class="grid grid--va-middle mb-8" *ngFor="let domain of domains.controls; let i = index">
                      <div class="grid__box">
                        <app-field>
                          <input class="input-text" type="text" id="i" [formControlName]="i" placeholder="Например, beeline.ru" />
                        </app-field>
                      </div>
                      <div class="grid__box grid__box--size-4">
                        <div class="grid">
                          <div class="grid__box grid__box--size-min" *ngIf="i == 0 || i == domains.controls.length - 1">
                            <button class="ctrl" id="appAddDomainCompany" (click)="addDomain()">
                              <span class="link link--dotted-blue-dark"> Добавить </span>
                            </button>
                          </div>
                          <div class="grid__box grid__box--size-min" *ngIf="i != 0">
                            <button class="ctrl" id="appRemoveDomainCompany" (click)="removeDomain(i)">
                              <span class="link link--dotted-blue-dark">Удалить</span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s"
                      >Участие в<br />
                      программе<br />
                      мотивации за up sale</span
                    >
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-checkbox-slider>
                      <input type="checkbox" id="upSale" formControlName="upsell_enabled" />
                    </app-checkbox-slider>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s title--required">Код партнера</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-field>
                      <input class="input-text" type="text" id="psPartnerCode" formControlName="partner_code" />
                    </app-field>
                  </div>
                </div>
                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s">Отображение в системе</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <app-checkbox-slider>
                      <input type="checkbox" id="isVisible" formControlName="is_visible" (change)="onChangeCompanyVisible($event)" />
                    </app-checkbox-slider>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid mt-24 mb-24">
          <div class="grid__box--size-4">
            <div class="grid">
              <div class="grid__box grid__box--size-5">
                <div class="delimiter delimiter--size-1 delimiter--gray-bright"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid">
          <div class="grid__box grid__box--size-2">
            <div class="title">Сведения об изменении данных</div>
          </div>
          <div class="grid__box grid__box--size-10">
            <div class="grid">
              <div class="grid__box grid__box--size-6">
                <div class="grid grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s">Дата создания</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      {{ currentSelectedCompany.create_date | dateFormat: 'DD MMMM YYYY г. HH:mm' }}
                    </div>
                    <div *ngIf="!isEditMode">
                      <div class="mdash"></div>
                    </div>
                  </div>
                </div>

                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s">Дата изменения</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      <div *ngIf="currentSelectedCompany.update_date">
                        {{ currentSelectedCompany.update_date | dateFormat: 'DD MMMM YYYY г.HH:mm' }}
                      </div>
                      <div *ngIf="!currentSelectedCompany.update_date" class="mdash"></div>
                    </div>
                    <div *ngIf="!isEditMode" class="mdash"></div>
                  </div>
                </div>

                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s">Создал</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      <a
                        [routerLink]="[
                          '/users',
                          {
                            u_id: currentSelectedCompany.created_by_user.user_id
                          }
                        ]"
                        class="link"
                      >
                        {{ currentSelectedCompany.created_by_user.full_name }}
                      </a>
                    </div>
                    <div *ngIf="!isEditMode">
                      <div class="mdash"></div>
                    </div>
                  </div>
                </div>

                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title-vertical title--s">Изменил</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      <div *ngIf="currentSelectedCompany.updated_by_user">
                        <a
                          [routerLink]="[
                            '/users',
                            {
                              u_id: currentSelectedCompany.updated_by_user.user_id
                            }
                          ]"
                          class="link"
                        >
                          {{ currentSelectedCompany.updated_by_user.full_name }}
                        </a>
                      </div>
                      <div *ngIf="!currentSelectedCompany.updated_by_user" class="mdash"></div>
                    </div>
                    <div *ngIf="!isEditMode">
                      <div class="mdash"></div>
                    </div>
                  </div>
                </div>

                <div class="grid mt-16 grid--va-middle">
                  <div class="grid__box grid__box--size-3">
                    <span class="title title--s">Версия</span>
                  </div>
                  <div class="grid__box grid__box--size-9">
                    <div *ngIf="isEditMode">
                      {{ currentSelectedCompany.version_number }}
                    </div>
                    <div *ngIf="!isEditMode">
                      <div class="mdash"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </step>
      <steps-errors [fieldsInvalid]="fieldsInvalid" [fieldsDescription]="fieldsDescription" [backendError]="backendError"></steps-errors>
    </steps>
  </form>
</div>
